<h2>{{ 'employeeModule.contractDetails' | translate }}</h2>
<form [formGroup]="form" #formRef="ngForm" *ngIf="contracts$ | async">
  <div class="mb-4">
    <label id="contractIdAriaLabel" class="form-label">
      {{ 'employeeModule.selectYourContract' | translate }}
    </label>

    <custom-select
      [ariaLabelledby]="'contractIdAriaLabel'"
      formControlName="contractId"
      [selectableItems]="
        contracts$
          | async
          | mapToSelectableItemsPipe: 'id' : 'description' : 'simple'
      "
      [clearable]="false"
      [valueBinder]="'id'"
      [emptyInitValue]="true"
      [allowSelectNullValue]="false"
      [placeholder]="['']"
    ></custom-select>
  </div>
</form>

<div class="text-center" [hidden]="!(isLoading$ | async)">
  <div
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'wcag.loading' | translate }}"
  ></div>
</div>

<div [hidden]="isLoading$ | async">
  <section
    *ngIf="contractValues$ | async as contractValues"
    class="card border mb-3"
  >
    <div class="card-body">
      <h3>
        {{ 'employeeModule.appointmentInHours' | translate }}
      </h3>
      <table class="table mb-4 table-sm">
        <tbody>
          <tr>
            <th scope="row">
              {{ 'employeeModule.brutto' | translate }}
            </th>

            <td>
              {{
                selectedContract?.contractHours
                  ? selectedContract?.contractHours
                  : '0.00'
              }}
            </td>
          </tr>

          <tr *ngIf="employeeModuleConfig.advancedContractDetails">
            <th scope="row">
              {{ 'employeeModule.vacationHours' | translate }}
            </th>

            <td>
              {{
                selectedContract?.vacationHours
                  ? selectedContract?.vacationHours
                  : '0.00'
              }}
            </td>
          </tr>

          <tr *ngIf="employeeModuleConfig.advancedContractDetails">
            <th scope="row">
              {{ 'employeeModule.nationalHolidayHours' | translate }}
            </th>
            <td>
              {{
                selectedContract?.nationalHolidayHours
                  ? selectedContract?.nationalHolidayHours
                  : '0.00'
              }}
            </td>
          </tr>

          <tr *ngIf="employeeModuleConfig.advancedContractDetails">
            <th scope="row">
              {{ 'employeeModule.hoursWorked' | translate }}
            </th>
            <td>
              {{
                selectedContract?.hoursWorked
                  ? selectedContract?.hoursWorked.toFixed(2)
                  : '0.00'
              }}
            </td>
          </tr>

          <tr *ngIf="employeeModuleConfig.advancedContractDetails">
            <th scope="row">
              {{ 'employeeModule.balancePreviousSeason' | translate }}
            </th>
            <td>
              {{
                selectedContract?.workHoursLeftPrevPeriod
                  ? selectedContract?.workHoursLeftPrevPeriod.toFixed(2)
                  : '0.00'
              }}
            </td>
          </tr>

          <tr *ngIf="employeeModuleConfig.advancedContractDetails">
            <th scope="row">
              {{ 'employeeModule.netto' | translate }}
            </th>
            <td>
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.netMinutes / 60)?.toFixed(2)
                )
              }}
              ({{ (contractValues?.netMinutes / 60)?.toFixed(2) }})
            </td>
          </tr>

          <!-- <tr *ngIf="!employeeModuleConfig.advancedContractDetails">
              <th scope="row">
                {{ 'employeeModule.amountOfBooking' | translate }}
              </th>
              <td>{{ amountOfEmployeeBookings }}</td>
            </tr> -->
        </tbody>
      </table>
      <h3>
        {{ 'employeeModule.workStatus' | translate }}
      </h3>
      <table class="table table-sm">
        <thead>
          <tr class="d-block d-md-table-row">
            <th scope="col" class="col-12 col-md-6 d-block d-md-table-cell">
            </th>
            <th scope="col" class="col-4 col-md-3" id="h-duration">{{
              'employeeModule.duration' | translate
            }}</th>
            <th
              scope="col"
              class="col-4 text-md-nowrap col-md-auto"
              *ngIf="!hidePeparationTimeColumn"
              id="h-prep-time"
            >
              {{ 'employeeModule.preparationHours' | translate }}
            </th>
            <th
              scope="col"
              class="col-4 text-md-nowrap col-md-auto"
              id="h-total"
              >{{ 'general.total' | translate }}</th
            >
          </tr>
        </thead>
        <tbody>
          <tr
            *ngIf="
              employeeModuleConfig && !employeeModuleConfig.showContractDetails
            "
          >
            <th scope="row" id="tr-1">
              {{ 'employeeModule.scheduledTaskDays' | translate }}
            </th>
            <td headers="tr-1 h-duration">
              {{ contractValues?.scheduledTaskDays?.toFixed(2) }}
            </td>
            <!-- TODO: add 3 values here -->
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              class="d-block d-md-table-cell col-12 col-md-6"
              id="tr-2"
              >{{ 'employeeModule.scheduledHours' | translate }}</th
            >
            <td class="col-4 col-md-auto" headers="tr-2 h-duration">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    contractValues?.scheduledMinutesWithoutPrepTime / 60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td
              class="col-4 col-md-auto"
              *ngIf="!hidePeparationTimeColumn"
              headers="tr-2 h-prep-time"
            >
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    (contractValues?.scheduledMinutesWithPrepTime -
                      contractValues?.scheduledMinutesWithoutPrepTime) /
                    60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td class="col-4 col-md-auto text-md-nowrap" headers="tr-2 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.scheduledMinutesWithPrepTime / 60)?.toFixed(
                    2
                  )
                )
              }}
              ({{
                (contractValues?.scheduledMinutesWithPrepTime / 60)?.toFixed(2)
              }})
            </td>
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              class="d-block d-md-table-cell col-12 col-md-6"
              id="tr-3"
            >
              {{ 'employeeModule.workedHours' | translate }}
            </th>
            <td class="col-4 col-md-auto" headers="tr-3 h-duration">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.workedMinutesWithoutPrepTime / 60)?.toFixed(
                    2
                  )
                )
              }}
            </td>
            <td
              class="col-4"
              *ngIf="!hidePeparationTimeColumn"
              headers="tr-3 h-prep-time"
            >
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    (contractValues?.workedMinutesWithPrepTime -
                      contractValues?.workedMinutesWithoutPrepTime) /
                    60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td class="col-4 col-md-auto" headers="tr-3 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.workedMinutesWithPrepTime / 60)?.toFixed(2)
                )
              }}
              ({{
                (contractValues?.workedMinutesWithPrepTime / 60)?.toFixed(2)
              }})
            </td>
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              class="d-block d-md-table-cell col-12 col-md-6"
              id="tr-4"
            >
              {{ 'employeeModule.leaveHours' | translate }}
            </th>
            <td class="col-4 col-md-auto" headers="tr-4 h-duration">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.leaveMinutesWithoutPrepTime / 60)?.toFixed(2)
                )
              }}
            </td>
            <td
              class="col-4 col-md-auto"
              *ngIf="!hidePeparationTimeColumn"
              headers="tr-4 h-prep-time"
            >
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    (contractValues?.leaveMinutesWithPrepTime -
                      contractValues?.leaveMinutesWithoutPrepTime) /
                    60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td class="col-4 col-md-auto" headers="tr-4 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.leaveMinutesWithPrepTime / 60)?.toFixed(2)
                )
              }}
              ({{
                (contractValues?.leaveMinutesWithPrepTime / 60)?.toFixed(2)
              }})
            </td>
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              class="d-block d-md-table-cell col-12 col-md-6"
              id="tr-5"
            >
              {{ 'employeeModule.specialLeaveHours' | translate }}
            </th>
            <td class="col-4 col-md-auto" headers="tr-5 h-duration">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    contractValues?.specialLeaveMinutesWithoutPrepTime / 60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td
              class="col-4 col-md-auto"
              *ngIf="!hidePeparationTimeColumn"
              headers="tr-5 h-prep-time"
            >
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    (contractValues?.specialLeaveMinutesWithPrepTime -
                      contractValues?.specialLeaveMinutesWithoutPrepTime) /
                    60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td class="col-4 col-md-auto" headers="tr-5 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    contractValues?.specialLeaveMinutesWithPrepTime / 60
                  )?.toFixed(2)
                )
              }}
              ({{
                (contractValues?.specialLeaveMinutesWithPrepTime / 60)?.toFixed(
                  2
                )
              }})
            </td>
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              class="d-block d-md-table-cell col-12 col-md-6"
              id="tr-6"
            >
              {{ 'employeeModule.sickLeaveHours' | translate }}
            </th>
            <td class="col-4 col-md-auto" headers="tr-6 h-duration">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    contractValues?.sickLeaveMinutesWithoutPrepTime / 60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td
              class="col-4 col-md-auto"
              *ngIf="!hidePeparationTimeColumn"
              headers="tr-6 h-prep-time"
            >
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (
                    (contractValues?.sickLeaveMinutesWithPrepTime -
                      contractValues?.sickLeaveMinutesWithoutPrepTime) /
                    60
                  )?.toFixed(2)
                )
              }}
            </td>
            <td class="col-4 col-md-auto" headers="tr-6 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.sickLeaveMinutesWithPrepTime / 60)?.toFixed(
                    2
                  )
                )
              }}
              ({{
                (contractValues?.sickLeaveMinutesWithPrepTime / 60)?.toFixed(2)
              }})
            </td>
          </tr>

          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              *ngIf="!hidePeparationTimeColumn"
              class="col-8 col-md-auto"
              colspan="3"
              id="tr-7"
            >
              {{ 'employeeModule.plusMinus' | translate }}
            </th>
            <td
              *ngIf="hidePeparationTimeColumn"
              class="col-8 col-md-auto"
              colspan="2"
            >
              {{ 'employeeModule.plusMinus' | translate }}
            </td>
            <td class="col-4 col-md-auto" headers="tr-7 h-total">
              {{
                employeeContractService.getTimeStringInHoursAndMinutes(
                  (contractValues?.plusMinusMinutes / 60)?.toFixed(2)
                )
              }}
              ({{ (contractValues?.plusMinusMinutes / 60)?.toFixed(2) }})
            </td>
          </tr>
          <tr
            *ngIf="employeeModuleConfig.advancedContractDetails"
            class="d-block d-md-table-row"
          >
            <th
              scope="row"
              *ngIf="!hidePeparationTimeColumn"
              class="col-8 col-md-auto"
              colspan="3"
              id="tr-8"
            >
              {{ 'employeeModule.hourlyRate' | translate }}
            </th>
            <td
              *ngIf="hidePeparationTimeColumn"
              class="col-8 col-md-auto"
              colspan="2"
            >
              {{ 'employeeModule.hourlyRate' | translate }}
            </td>
            <td
              class="col-4 col-md-auto"
              data-test-id="employee-contract-hourly-rate"
              headers="tr-8 h-total"
            >
              {{ this.contractSalary }}&euro;
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
